export default "/assets/2a0783bd1c6c1469558bfa573cfa0c0c.woff2";